import { useState } from "react";
import config from '../config.js';
import axios from "axios";

const BookModal = ({ setCurrentModal, bookModalRef, formData }) => {

  const [bookData, setBookData] = useState({
    bookName: '',
    bookEmail: '',
    bookPhone: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    setBookData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Show loading modal
    setCurrentModal("loadingModal");

    // Merge form 1 data with form 2 (book form) data
    const submissionData = {
      destination: formData.destination,
      budget: formData.budget,
      length: formData.length,
      person: formData.person,
      bookName: bookData.bookName,
      bookEmail: bookData.bookEmail,
      bookPhone: bookData.bookPhone
    }

    console.log(submissionData);

    // Try-Catch to wrap Axios HTTP request
    try {
      const response = await axios.post(`${config.baseUrl}/book`, submissionData);

      // Success handler
      if (response.status === 201) {
        console.log(response);
        setTimeout(() => {
          setCurrentModal("bookSuccessModal");
        }, 1000);
      } else {
        console.log(response);
        setTimeout(() => {
          setCurrentModal("errorModal");
        }, 1000);
      }
    } catch {
      setTimeout(() => {
        setCurrentModal("errorModal");
      }, 1000);
    }
  }

  return (
    <>
      {/* Result Modal */}
      <div className="modal fade" ref={bookModalRef} id="modalBook" tabIndex="-1" aria-labelledby="modalBookTitle" aria-hidden="true">
        <div className="modal-dialog modal-lg">
          <div className="modal-content px-4 py-3">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="modalBookTitle">Book Your Trip!</h1>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <p>Fill out the form with your details, and our team will get in touch with you to guide you through the next steps of your booking process.</p>
              <div className="form2-cont">
                {/* Form */}
                <form className="form2" onSubmit={handleSubmit}>
                  <div className="form2-item">
                    <label className="form2-label">Full Name*</label>
                    <div className="form2-field-cont">
                      <input
                        type="text"
                        className="form2-field"
                        name="bookName"
                        placeholder="e.g. John Doe"
                        onChange={handleChange}
                        required 
                      />
                    </div>
                  </div>
                  
                  <div className="form2-item">
                    <label className="form2-label">Email*</label>
                    <div className="form2-field-cont">
                      <input
                        type="email"
                        className="form2-field"
                        name="bookEmail"
                        placeholder="e.g. john@doe.com"
                        onChange={handleChange}
                        required 
                      />
                    </div>
                  </div>
                  
                  <div className="form2-item">
                    <label className="form2-label">Mobile Phone Number*</label>
                    <div className="form2-field-cont">
                      <input
                        type="number"
                        className="form2-field"
                        name="bookPhone"
                        placeholder="62888999000"
                        onChange={handleChange}
                        required 
                      />
                    </div>
                  </div>

                  <div className="form2-item mod-btn-cont">
                    <button className="modal-btn btn btn-grad form2-btn">Submit</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default BookModal